<onyx-map></onyx-map>

<section>
  @if (!contractor().branches.length) {
    <h6>{{ 'labels.mainBranch' | translate }}</h6>
  } @else {
    <onyx-chips
      [chips]="branches()"
      variant="secondary"
      [single]="true"
      [gap]="12"
      [(activeValues)]="activeBranch"
    ></onyx-chips>
  }

  @let branch = activeBranch()[0];
  @let addresses = branch.addresses;

  <onyx-information-list>
    <onyx-information-row
      [label]="`labels.${branch === contractor() ? 'mainAddress' : 'branchAddress'}`"
    >
      <onyx-address
        [address]="addresses.mainAddress"
        format="full"
        [showFlag]="false"
      ></onyx-address>
    </onyx-information-row>

    <onyx-information-row label="labels.correspondenceAddress">
      <onyx-address
        [address]="addresses.correspondenceAddress"
        format="full"
        [showFlag]="false"
      ></onyx-address>
    </onyx-information-row>
  </onyx-information-list>
</section>

<app-contractor-shipping-methods
  [invoice]="invoice()"
  [invoiceDocuments]="invoiceDocuments()"
>
</app-contractor-shipping-methods>

@if (!invoiceDocuments() && !invoice() && hasEdit()) {
  <div class="empty">
    <onyx-empty-state>
      <onyx-icon class="icon" name="contractor-filled" [size]="32"></onyx-icon>
    </onyx-empty-state>

    <p class="description">
      <span class="f-body-l f-medium">
        {{ `${I18N}.fillInvoiceSettings` | translate }}
      </span>

      <span class="f-body-s f-muted">
        {{ `${I18N}.fillInvoiceSettingsHint` | translate }}
      </span>
    </p>

    <onyx-button (click)="edit()">
      {{ 'labels.fillNow' | translate }}
    </onyx-button>
  </div>
}
